module.exports = __webpack_public_path__ + "static/media/article-logo.2e961cd5.jpg";